import { render } from "./AdminDataFeiertage.vue?vue&type=template&id=377b8a6a"
import script from "./AdminDataFeiertage.vue?vue&type=script&lang=js"
export * from "./AdminDataFeiertage.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__